import { render, staticRenderFns } from "./weixin.vue?vue&type=template&id=a524f110&scoped=true"
import script from "./weixin.vue?vue&type=script&lang=js"
export * from "./weixin.vue?vue&type=script&lang=js"
import style0 from "./weixin.vue?vue&type=style&index=0&id=a524f110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a524f110",
  null
  
)

export default component.exports